import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
class NotificationAddV2 extends React.Component {
  state = {
    title: '',
    message: '',
    isData: false,
    Edit: false,
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  addNotification = () => {
    var that = this
    that.setState({ isSaving: true })
    var data = {
      pushTitle: that.state.title,
      message: that.state.message,
    }
    this.setState({ isData: true })
    axios
      .post(Constant.getAPI() + '/admin/send-push', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Notification sent Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = '#/notification-v2'
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onSaveData = () => {
    var that = this
    that.setState({ isSaving: true })

    that.addNotification()
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Notification</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/notification-v2">Notification</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div className="">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Title</label>
                                <div className="col-sm-10">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="title"
                                    id="title"
                                    placeholder="title"
                                    onChange={this.handleChange}
                                    value={this.state.title}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group row">
                                <label className="col-sm-2 col-form-label">Message</label>
                                <div className="col-sm-10">
                                  {/* <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="message"
                                                                        id="message"
                                                                        placeholder="message"
                                                                        onChange={this.handleChange}
                                                                        value={this.state.message}
                                                                    /> */}
                                  <textarea
                                    type="text"
                                    className="form-control"
                                    name="message"
                                    id="message"
                                    placeholder="message"
                                    onChange={this.handleChange}
                                    value={this.state.message}
                                    rows="4"
                                    cols="50"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div className="row">
                              <div className="text-right col-6 offset-6">
                                {this.state.isData ? (
                                  <button
                                    className="btn btn-grd-disabled mr-2"
                                    disabled
                                  >
                                    Sending...!
                                  </button>
                                ) : (
                                  <button
                                    onClick={this.onSaveData}
                                    className="btn hor-grd btn-grd-inverse offset-1"
                                  >
                                    <i className="ti-save"></i>Send
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NotificationAddV2
